"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: commercial_property/commercial_map_page.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialPropertiesFilter = exports.CommercialMapPageBoundarySearchResponse = exports.CommercialMapPageBoundarySearchRequest = exports.CommercialMapPageCluster = exports.PointCoordinates = exports.CommercialMapPageClusterResponse = exports.CommercialMapPageClusterRequest = exports.CommercialMapPageFilter = exports.LatLonAsArray = exports.Geohash = exports.SortBy = exports.protobufPackage = void 0;
exports.sortByFromJSON = sortByFromJSON;
exports.sortByToJSON = sortByToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const commercial_listings_1 = require("./commercial_listings");
exports.protobufPackage = "commercial_property";
var SortBy;
(function (SortBy) {
    SortBy[SortBy["SORT_BY_UNSPECIFIED"] = 0] = "SORT_BY_UNSPECIFIED";
    SortBy[SortBy["SORT_BY_PRICE_ASC"] = 1] = "SORT_BY_PRICE_ASC";
    SortBy[SortBy["SORT_BY_PRICE_DESC"] = 2] = "SORT_BY_PRICE_DESC";
    SortBy[SortBy["SORT_BY_API_MODIFICATION_TIMESTAMP_ASC"] = 3] = "SORT_BY_API_MODIFICATION_TIMESTAMP_ASC";
    SortBy[SortBy["SORT_BY_API_MODIFICATION_TIMESTAMP_DESC"] = 4] = "SORT_BY_API_MODIFICATION_TIMESTAMP_DESC";
    SortBy[SortBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SortBy || (exports.SortBy = SortBy = {}));
function sortByFromJSON(object) {
    switch (object) {
        case 0:
        case "SORT_BY_UNSPECIFIED":
            return SortBy.SORT_BY_UNSPECIFIED;
        case 1:
        case "SORT_BY_PRICE_ASC":
            return SortBy.SORT_BY_PRICE_ASC;
        case 2:
        case "SORT_BY_PRICE_DESC":
            return SortBy.SORT_BY_PRICE_DESC;
        case 3:
        case "SORT_BY_API_MODIFICATION_TIMESTAMP_ASC":
            return SortBy.SORT_BY_API_MODIFICATION_TIMESTAMP_ASC;
        case 4:
        case "SORT_BY_API_MODIFICATION_TIMESTAMP_DESC":
            return SortBy.SORT_BY_API_MODIFICATION_TIMESTAMP_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SortBy.UNRECOGNIZED;
    }
}
function sortByToJSON(object) {
    switch (object) {
        case SortBy.SORT_BY_UNSPECIFIED:
            return "SORT_BY_UNSPECIFIED";
        case SortBy.SORT_BY_PRICE_ASC:
            return "SORT_BY_PRICE_ASC";
        case SortBy.SORT_BY_PRICE_DESC:
            return "SORT_BY_PRICE_DESC";
        case SortBy.SORT_BY_API_MODIFICATION_TIMESTAMP_ASC:
            return "SORT_BY_API_MODIFICATION_TIMESTAMP_ASC";
        case SortBy.SORT_BY_API_MODIFICATION_TIMESTAMP_DESC:
            return "SORT_BY_API_MODIFICATION_TIMESTAMP_DESC";
        case SortBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseGeohash() {
    return { topLeft: "", bottomRight: "" };
}
exports.Geohash = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.topLeft !== "") {
            writer.uint32(10).string(message.topLeft);
        }
        if (message.bottomRight !== "") {
            writer.uint32(18).string(message.bottomRight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGeohash();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.topLeft = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.bottomRight = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topLeft: isSet(object.topLeft) ? globalThis.String(object.topLeft) : "",
            bottomRight: isSet(object.bottomRight) ? globalThis.String(object.bottomRight) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.topLeft !== "") {
            obj.topLeft = message.topLeft;
        }
        if (message.bottomRight !== "") {
            obj.bottomRight = message.bottomRight;
        }
        return obj;
    },
    create(base) {
        return exports.Geohash.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGeohash();
        message.topLeft = (_a = object.topLeft) !== null && _a !== void 0 ? _a : "";
        message.bottomRight = (_b = object.bottomRight) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseLatLonAsArray() {
    return { topLeft: [], bottomRight: [] };
}
exports.LatLonAsArray = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        writer.uint32(10).fork();
        for (const v of message.topLeft) {
            writer.float(v);
        }
        writer.join();
        writer.uint32(18).fork();
        for (const v of message.bottomRight) {
            writer.float(v);
        }
        writer.join();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLatLonAsArray();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag === 13) {
                        message.topLeft.push(reader.float());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.topLeft.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
                case 2: {
                    if (tag === 21) {
                        message.bottomRight.push(reader.float());
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.bottomRight.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topLeft: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.topLeft) ? object.topLeft.map((e) => globalThis.Number(e)) : [],
            bottomRight: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.bottomRight)
                ? object.bottomRight.map((e) => globalThis.Number(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if ((_a = message.topLeft) === null || _a === void 0 ? void 0 : _a.length) {
            obj.topLeft = message.topLeft;
        }
        if ((_b = message.bottomRight) === null || _b === void 0 ? void 0 : _b.length) {
            obj.bottomRight = message.bottomRight;
        }
        return obj;
    },
    create(base) {
        return exports.LatLonAsArray.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseLatLonAsArray();
        message.topLeft = ((_a = object.topLeft) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.bottomRight = ((_b = object.bottomRight) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseCommercialMapPageFilter() {
    return { latLonAsArray: undefined, latLonAsGeohash: undefined, filter: undefined, precision: undefined };
}
exports.CommercialMapPageFilter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.latLonAsArray !== undefined) {
            exports.LatLonAsArray.encode(message.latLonAsArray, writer.uint32(10).fork()).join();
        }
        if (message.latLonAsGeohash !== undefined) {
            exports.Geohash.encode(message.latLonAsGeohash, writer.uint32(18).fork()).join();
        }
        if (message.filter !== undefined) {
            exports.CommercialPropertiesFilter.encode(message.filter, writer.uint32(26).fork()).join();
        }
        if (message.precision !== undefined) {
            writer.uint32(32).uint32(message.precision);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialMapPageFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.latLonAsArray = exports.LatLonAsArray.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.latLonAsGeohash = exports.Geohash.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.filter = exports.CommercialPropertiesFilter.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.precision = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            latLonAsArray: isSet(object.latLonAsArray) ? exports.LatLonAsArray.fromJSON(object.latLonAsArray) : undefined,
            latLonAsGeohash: isSet(object.latLonAsGeohash) ? exports.Geohash.fromJSON(object.latLonAsGeohash) : undefined,
            filter: isSet(object.filter) ? exports.CommercialPropertiesFilter.fromJSON(object.filter) : undefined,
            precision: isSet(object.precision) ? globalThis.Number(object.precision) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.latLonAsArray !== undefined) {
            obj.latLonAsArray = exports.LatLonAsArray.toJSON(message.latLonAsArray);
        }
        if (message.latLonAsGeohash !== undefined) {
            obj.latLonAsGeohash = exports.Geohash.toJSON(message.latLonAsGeohash);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.CommercialPropertiesFilter.toJSON(message.filter);
        }
        if (message.precision !== undefined) {
            obj.precision = Math.round(message.precision);
        }
        return obj;
    },
    create(base) {
        return exports.CommercialMapPageFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCommercialMapPageFilter();
        message.latLonAsArray = (object.latLonAsArray !== undefined && object.latLonAsArray !== null)
            ? exports.LatLonAsArray.fromPartial(object.latLonAsArray)
            : undefined;
        message.latLonAsGeohash = (object.latLonAsGeohash !== undefined && object.latLonAsGeohash !== null)
            ? exports.Geohash.fromPartial(object.latLonAsGeohash)
            : undefined;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.CommercialPropertiesFilter.fromPartial(object.filter)
            : undefined;
        message.precision = (_a = object.precision) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseCommercialMapPageClusterRequest() {
    return { sortBy: 0, filter: undefined };
}
exports.CommercialMapPageClusterRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sortBy !== 0) {
            writer.uint32(8).int32(message.sortBy);
        }
        if (message.filter !== undefined) {
            exports.CommercialMapPageFilter.encode(message.filter, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialMapPageClusterRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.sortBy = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filter = exports.CommercialMapPageFilter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sortBy: isSet(object.sortBy) ? sortByFromJSON(object.sortBy) : 0,
            filter: isSet(object.filter) ? exports.CommercialMapPageFilter.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sortBy !== 0) {
            obj.sortBy = sortByToJSON(message.sortBy);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.CommercialMapPageFilter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.CommercialMapPageClusterRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCommercialMapPageClusterRequest();
        message.sortBy = (_a = object.sortBy) !== null && _a !== void 0 ? _a : 0;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.CommercialMapPageFilter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseCommercialMapPageClusterResponse() {
    return { clusters: [] };
}
exports.CommercialMapPageClusterResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.clusters) {
            exports.CommercialMapPageCluster.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialMapPageClusterResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.clusters.push(exports.CommercialMapPageCluster.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            clusters: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.clusters)
                ? object.clusters.map((e) => exports.CommercialMapPageCluster.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.clusters) === null || _a === void 0 ? void 0 : _a.length) {
            obj.clusters = message.clusters.map((e) => exports.CommercialMapPageCluster.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CommercialMapPageClusterResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCommercialMapPageClusterResponse();
        message.clusters = ((_a = object.clusters) === null || _a === void 0 ? void 0 : _a.map((e) => exports.CommercialMapPageCluster.fromPartial(e))) || [];
        return message;
    },
};
function createBasePointCoordinates() {
    return { lat: 0, lon: 0 };
}
exports.PointCoordinates = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.lat !== 0) {
            writer.uint32(13).float(message.lat);
        }
        if (message.lon !== 0) {
            writer.uint32(21).float(message.lon);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePointCoordinates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 13) {
                        break;
                    }
                    message.lat = reader.float();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.lon = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            lat: isSet(object.lat) ? globalThis.Number(object.lat) : 0,
            lon: isSet(object.lon) ? globalThis.Number(object.lon) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.lat !== 0) {
            obj.lat = message.lat;
        }
        if (message.lon !== 0) {
            obj.lon = message.lon;
        }
        return obj;
    },
    create(base) {
        return exports.PointCoordinates.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePointCoordinates();
        message.lat = (_a = object.lat) !== null && _a !== void 0 ? _a : 0;
        message.lon = (_b = object.lon) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseCommercialMapPageCluster() {
    return { coordinates: undefined, listings: [], count: 0, geohash: "", key: "" };
}
exports.CommercialMapPageCluster = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.coordinates !== undefined) {
            exports.PointCoordinates.encode(message.coordinates, writer.uint32(10).fork()).join();
        }
        for (const v of message.listings) {
            commercial_listings_1.CommercialPropertyClusterItem.encode(v, writer.uint32(18).fork()).join();
        }
        if (message.count !== 0) {
            writer.uint32(24).int32(message.count);
        }
        if (message.geohash !== "") {
            writer.uint32(34).string(message.geohash);
        }
        if (message.key !== "") {
            writer.uint32(42).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialMapPageCluster();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.coordinates = exports.PointCoordinates.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.listings.push(commercial_listings_1.CommercialPropertyClusterItem.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.count = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.geohash = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            coordinates: isSet(object.coordinates) ? exports.PointCoordinates.fromJSON(object.coordinates) : undefined,
            listings: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.listings)
                ? object.listings.map((e) => commercial_listings_1.CommercialPropertyClusterItem.fromJSON(e))
                : [],
            count: isSet(object.count) ? globalThis.Number(object.count) : 0,
            geohash: isSet(object.geohash) ? globalThis.String(object.geohash) : "",
            key: isSet(object.key) ? globalThis.String(object.key) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.coordinates !== undefined) {
            obj.coordinates = exports.PointCoordinates.toJSON(message.coordinates);
        }
        if ((_a = message.listings) === null || _a === void 0 ? void 0 : _a.length) {
            obj.listings = message.listings.map((e) => commercial_listings_1.CommercialPropertyClusterItem.toJSON(e));
        }
        if (message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        if (message.geohash !== "") {
            obj.geohash = message.geohash;
        }
        if (message.key !== "") {
            obj.key = message.key;
        }
        return obj;
    },
    create(base) {
        return exports.CommercialMapPageCluster.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseCommercialMapPageCluster();
        message.coordinates = (object.coordinates !== undefined && object.coordinates !== null)
            ? exports.PointCoordinates.fromPartial(object.coordinates)
            : undefined;
        message.listings = ((_a = object.listings) === null || _a === void 0 ? void 0 : _a.map((e) => commercial_listings_1.CommercialPropertyClusterItem.fromPartial(e))) || [];
        message.count = (_b = object.count) !== null && _b !== void 0 ? _b : 0;
        message.geohash = (_c = object.geohash) !== null && _c !== void 0 ? _c : "";
        message.key = (_d = object.key) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseCommercialMapPageBoundarySearchRequest() {
    return { sortBy: 0, filter: undefined };
}
exports.CommercialMapPageBoundarySearchRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sortBy !== 0) {
            writer.uint32(8).int32(message.sortBy);
        }
        if (message.filter !== undefined) {
            exports.CommercialMapPageFilter.encode(message.filter, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialMapPageBoundarySearchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.sortBy = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filter = exports.CommercialMapPageFilter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sortBy: isSet(object.sortBy) ? sortByFromJSON(object.sortBy) : 0,
            filter: isSet(object.filter) ? exports.CommercialMapPageFilter.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sortBy !== 0) {
            obj.sortBy = sortByToJSON(message.sortBy);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.CommercialMapPageFilter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.CommercialMapPageBoundarySearchRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCommercialMapPageBoundarySearchRequest();
        message.sortBy = (_a = object.sortBy) !== null && _a !== void 0 ? _a : 0;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.CommercialMapPageFilter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseCommercialMapPageBoundarySearchResponse() {
    return { properties: [], pageSize: 0, totalCount: 0, totalPages: 0, nextPage: "" };
}
exports.CommercialMapPageBoundarySearchResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.properties) {
            commercial_listings_1.CommercialPropertyBoundaryItem.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.pageSize !== 0) {
            writer.uint32(16).uint32(message.pageSize);
        }
        if (message.totalCount !== 0) {
            writer.uint32(24).uint32(message.totalCount);
        }
        if (message.totalPages !== 0) {
            writer.uint32(32).uint32(message.totalPages);
        }
        if (message.nextPage !== "") {
            writer.uint32(42).string(message.nextPage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialMapPageBoundarySearchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.properties.push(commercial_listings_1.CommercialPropertyBoundaryItem.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.pageSize = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.totalCount = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.totalPages = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.nextPage = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            properties: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.properties)
                ? object.properties.map((e) => commercial_listings_1.CommercialPropertyBoundaryItem.fromJSON(e))
                : [],
            pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
            totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
            totalPages: isSet(object.totalPages) ? globalThis.Number(object.totalPages) : 0,
            nextPage: isSet(object.nextPage) ? globalThis.String(object.nextPage) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.properties) === null || _a === void 0 ? void 0 : _a.length) {
            obj.properties = message.properties.map((e) => commercial_listings_1.CommercialPropertyBoundaryItem.toJSON(e));
        }
        if (message.pageSize !== 0) {
            obj.pageSize = Math.round(message.pageSize);
        }
        if (message.totalCount !== 0) {
            obj.totalCount = Math.round(message.totalCount);
        }
        if (message.totalPages !== 0) {
            obj.totalPages = Math.round(message.totalPages);
        }
        if (message.nextPage !== "") {
            obj.nextPage = message.nextPage;
        }
        return obj;
    },
    create(base) {
        return exports.CommercialMapPageBoundarySearchResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseCommercialMapPageBoundarySearchResponse();
        message.properties = ((_a = object.properties) === null || _a === void 0 ? void 0 : _a.map((e) => commercial_listings_1.CommercialPropertyBoundaryItem.fromPartial(e))) || [];
        message.pageSize = (_b = object.pageSize) !== null && _b !== void 0 ? _b : 0;
        message.totalCount = (_c = object.totalCount) !== null && _c !== void 0 ? _c : 0;
        message.totalPages = (_d = object.totalPages) !== null && _d !== void 0 ? _d : 0;
        message.nextPage = (_e = object.nextPage) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseCommercialPropertiesFilter() {
    return { statesOrProvinces: [], cities: [], propertySubTypes: [] };
}
exports.CommercialPropertiesFilter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.statesOrProvinces) {
            writer.uint32(10).string(v);
        }
        for (const v of message.cities) {
            writer.uint32(18).string(v);
        }
        for (const v of message.propertySubTypes) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialPropertiesFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.statesOrProvinces.push(reader.string());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.cities.push(reader.string());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.propertySubTypes.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            statesOrProvinces: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.statesOrProvinces)
                ? object.statesOrProvinces.map((e) => globalThis.String(e))
                : [],
            cities: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.cities) ? object.cities.map((e) => globalThis.String(e)) : [],
            propertySubTypes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertySubTypes)
                ? object.propertySubTypes.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b, _c;
        const obj = {};
        if ((_a = message.statesOrProvinces) === null || _a === void 0 ? void 0 : _a.length) {
            obj.statesOrProvinces = message.statesOrProvinces;
        }
        if ((_b = message.cities) === null || _b === void 0 ? void 0 : _b.length) {
            obj.cities = message.cities;
        }
        if ((_c = message.propertySubTypes) === null || _c === void 0 ? void 0 : _c.length) {
            obj.propertySubTypes = message.propertySubTypes;
        }
        return obj;
    },
    create(base) {
        return exports.CommercialPropertiesFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCommercialPropertiesFilter();
        message.statesOrProvinces = ((_a = object.statesOrProvinces) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.cities = ((_b = object.cities) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.propertySubTypes = ((_c = object.propertySubTypes) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=commercial_map_page.js.map